import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IClinicToClinicTransferStatusListResponse } from "@/api_framework/api_modals/Inventory";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setTransferStatusList } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

export const useOrderTransferStatusListAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(INVENTORY_MODULE?.ORDER_TRANSFER_STATUS_LIST?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IClinicToClinicTransferStatusListResponse>) => {
          if (res.data.status === true) {
            dispatch(setTransferStatusList({ data: res.data.data }));
          } else {
            dispatch(setTransferStatusList({ data: [] }));
          }
        })
        .catch((e: AxiosError) => {
          captureError(e)
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
